import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/billing-reasons.js';
import q from '../query.js';
export const billingReasonEntity = `billing-reasons`;
const billingReasonKey = (depositCaseVoucherId, billingId) => `billing-reason-${billingId}-${depositCaseVoucherId}`;
export const useBillingReasons = (depositCaseVoucherId, billingId) => q.query(billingReasonKey(depositCaseVoucherId, billingId), () => api.get(depositCaseVoucherId, billingId), keys.read.collection(billingReasonEntity));
//# sourceMappingURL=index.js.map